import DuckEntity from './DuckEntity'

const entity = new DuckEntity('schedules');
const reducer = entity.reducer;
export {reducer as default, entity};
